import { render, staticRenderFns } from "./payments-list.vue?vue&type=template&id=81e478a6"
import script from "./payments-list.vue?vue&type=script&lang=js"
export * from "./payments-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports